<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SettingDrawer',
})
</script>
<template>
    <div>
        <a-drawer :bodyStyle="{ padding: 0 }" width="1200" placement="right" :maskStyle="{ background: '#0000001a' }"
            @after-open-change="afterOpenChange" @close="onClose" :closable="false" :open="$store.state.showWXInform">
            <div class="inform-drawer">
                <!-- 左侧联系人列表 -->
                <div class="drawer-left" style="width: 35%">
                    <div class="title">
                        微信公众号信息
                        <span v-if="data.menuCount > 0" class="count-badge">{{ data.menuCount }}</span>
                    </div>
                    <div class="menus" style="overflow-y: auto; height: 90%; max-height: 700px" @scroll="handleScroll">
                        <div class="menus-item" :class="{ active: data.lianxiren.key == item.key }"
                            @click="selectMenus(item)" v-for="(item, index) in menusList" :key="index">
                            <a-row style="width: 100%">
                                <a-col :span="6">
                                    <div style="width: 60px; height: 60px; border-radius: 5px; text-align: center; padding: 3px; font-size: 14px; color: #fff; display: flex; justify-content: center; align-items: center"
                                        :title="item.side_roles_title" :class="'avater' + item.side_roles_class">
                                        {{ item.side_roles_name }}
                                    </div>
                                </a-col>
                                <a-col :span="16">
                                    <p class="contact-name">{{ item.companyname }}</p>
                                    <p class="contact-lastmsg">{{ item.lastmsg }}</p>
                                    <p class="contact-time">{{ item.created_at }}</p>
                                </a-col>
                                <a-col :span="2">
                                    <a-badge color="#1677ff" :count="item.inform"> </a-badge>
                                    <a-tag color="#f50" v-if="item.is_top == 1" class="mt-1x"
                                        style="margin-left: -10px">置顶</a-tag>
                                </a-col>
                            </a-row>
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center">
                            <a-spin :spinning="data.menuLoading"></a-spin>
                        </div>
                    </div>
                </div>

                <!-- 右侧聊天区域（完全交由 Inform 组件处理） -->
                <div class="drawer-right chat-panel" style="display: flex; flex-direction: column; height: 100%;">
                    <!-- 聊天头部 -->
                    <div class="chat-header"
                        style="flex-shrink: 0; background: #fff; padding: 15px 20px; border-bottom: 1px solid #eee;">
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <div style="display: flex; align-items: center;">
                                <span style="font-size: 16px; font-weight: 600; color: #333;">{{
                                    data.lianxiren.companyname }}</span>
                                <a-switch @click="toTopClick(data.lianxiren)"
                                    :checked="data.lianxiren.is_top == 1 ? true : false" checked-children="已置顶"
                                    un-checked-children="未置顶" :loading="data.topLoading" size="small"
                                    style="margin-left: 12px" />
                            </div>
                        </div>
                        <p style="font-size: 12px; color: #999; margin: 5px 0 0 0;" v-if="data.lianxiren.address">
                            入驻地址：{{ data.lianxiren.address }}</p>
                    </div>

                    <!-- 聊天内容与输入框（占满剩余高度） -->
                    <div style="flex: 1; overflow: hidden; display: flex; flex-direction: column;">
                        <Inform :lianxirenData="data.lianxiren" style="height: 100%;"></Inform>
                    </div>
                </div>
            </div>
            <template #handle>
                <div class="inform-drawer-index-handle" v-if="$store.state.showWXInform" @click="onClose">
                    <CloseOutlined style="color: #fff" />
                </div>
            </template>
        </a-drawer>
    </div>
</template>

<script lang="ts" setup name="SettingDrawer">
import { CloseOutlined, CopyOutlined, UserOutlined, BellOutlined } from '@ant-design/icons-vue'
import Inform from './components/inform.vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { ref, reactive } from 'vue'
import type { PaginationProps } from 'ant-design-vue'
import baseService from '@/utils/http/axios'

const $store = useStore()

interface data {
    menuLoading: boolean
    menuCount: number
    lianxiren: {
        customer_id: number
        side: number
        companyname: string
        upload_path: string
        address: string
        key: string
        is_top: number
    }
    topLoading: boolean
}

const data = reactive<data>({
    menuLoading: false,
    menuCount: 0,
    lianxiren: {
        customer_id: 0,
        side: 0,
        companyname: '',
        upload_path: '',
        address: '',
        key: '',
        is_top: 0
    },
    topLoading: false
})

// 消息列表
const menusList = ref<any>([])
const menusPagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '200'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})

const selectMenus = (item) => {
    data.lianxiren = {
        customer_id: item.customer_id,
        side: item.side,
        companyname: item.companyname,
        upload_path: item.upload_path,
        address: item.address,
        key: item.key,
        is_top: item.is_top
    }
    // 清空未读标记
    item.inform = 0
}

// 打开弹出-初始化
const afterOpenChange = (bool: boolean) => {
    if (bool) {
        menusList.value = []
        menusPagination.current = 1
        data.menuCount = 0
        data.menuLoading = false
        data.lianxiren = {
            customer_id: 0,
            side: 0,
            companyname: '',
            upload_path: '',
            address: '',
            key: '',
            is_top: 0
        }
        loadLianxiren()
    }
}

const onClose = () => {
    $store.commit('SET_SHOW_WXINFORM', false)
}

// 联系人列表滚动加载
const handleScroll = (event) => {
    if (!data.menuLoading && (data.menuCount == 0 || data.menuCount > menusList.value.length)) {
        const { scrollTop, scrollHeight, clientHeight } = event.target
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (menusPagination.current) {
                menusPagination.current++
                loadLianxiren()
            }
        }
    }
}

const loadLianxiren = () => {
    data.menuLoading = true
    let requestParam = {
        url: '/admin/v1/chatlist',
        method: 'post',
        data: {
            page: menusPagination.current,
            page_size: menusPagination.pageSize
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            data.menuLoading = false
            res.data.list.forEach((item) => {
                menusList.value.push(item)
            })
            data.menuCount = res.data.total_records
            if (menusPagination.current == 1 && menusList.value.length > 0) {
                selectMenus(menusList.value[0])
            }
        })
        .catch((res) => {
            data.menuLoading = false
            message.error(res.msg || '查询微信消息失败！')
        })
}

// 置顶
const toTopClick = (record) => {
    data.topLoading = true
    let requestParam = {
        url: '/admin/v1/chatTop',
        method: 'post',
        data: {
            customer_id: record.customer_id,
            side: record.side,
            is_top: record.is_top == 1 ? 0 : 1
        }
    }
    baseService(requestParam)
        .then(() => {
            data.topLoading = false
            afterOpenChange(true)
        })
        .catch((res) => {
            data.topLoading = false
            message.error(res.msg || '置顶失败！')
        })
}
</script>

<style lang="less" scoped>
@import './index.less';

.count-badge {
    display: inline-block;
    background: #f56c6c;
    color: #fff;
    font-size: 12px;
    border-radius: 10px;
    padding: 0 6px;
    margin-left: 6px;
    line-height: 18px;
}

.menus-item {
    cursor: pointer;
    padding: 8px 10px;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.2s;

    &:hover {
        background: #f5f5f5;
    }

    &.active {
        background: #ebecf0;
    }
}

.contact-name {
    font-weight: 500;
    font-size: 14px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contact-lastmsg {
    font-size: 12px;
    color: #888;
    margin: 2px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contact-time {
    font-size: 10px;
    color: #aaa;
    margin: 2px 0 0;
}

/* 头像颜色保留 */
.avater0 {
    background-color: red;
}

.avater1 {
    background-color: #13c2c2;
}

.avater2 {
    background-color: red;
}

.avater3 {
    background-color: #3f8cff;
}

.avater4 {
    background-color: red;
}

.avater5 {
    background-color: red;
}

.avater6 {
    background-color: red;
}

.avater7 {
    background-color: #faad14;
}

.avater8 {
    background-color: red;
}

.avater9 {
    background-color: red;
}

.avater10 {
    background-color: red;
}

.avater11 {
    background-color: red;
}

.avater12 {
    background-color: red;
}

.avater13 {
    background-color: red;
}
</style>
